import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Card,
  CardContent,
  CardMedia,
  Grid,
  useTheme,
  Paper,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import cabinet from "../../images/cabinet.png";
import hpower from "../../images/power_system.png";
import "../dashboard/styles.css";

const HistoricalData = () => {
  const navigate = useNavigate();
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/historical_data");
    }
  }, [navigate]);

  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Typography key="4" sx={{ color: "text.primary" }}>
      Historical Data
    </Typography>,
  ];

  // Theme for responsive styling
  const theme = useTheme();

  // Sample data for the cards
  const cardData = [
    {
      title: "Smart Cabinet",
      imageUrl: cabinet,
    },
    {
      title: "Hybrid UPS",
      imageUrl: hpower,
    },
  ];

  const handleCardClick = (title) => {
    sessionStorage.setItem("stateName", stateName);
    sessionStorage.setItem("siteId", siteId);
    if (title === "Hybrid UPS") {
      navigate("/hybrid_ups");
    } else {
      navigate("/outdoor_cabinet");
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={2}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="medium" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {siteId}
              </Typography>
            </Box>
            <br />
            <br />

            <div className="card-container">
              {cardData.length > 0 ? (
                cardData.map((card, index) => (
                  <div
                    className="card"
                    key={index}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => handleCardClick(card.title)}
                  >
                    <img
                      className="card-image"
                      src={card.imageUrl}
                      alt={card.title}
                    />
                    <h5 className="card-title">{card.title}</h5>
                  </div>
                ))
              ) : (
                <p>No results found.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default HistoricalData;
